import React from "react";
import { Calendar, Edit3, Trash2, Loader2 } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { toast } from "@/components/ui/sonner";
import api, { formatApiError } from "@/lib/api";

export const EventsTab = ({ events, loading, onEdit, onChanged }) => {
    const removeEvent = async (ev) => {
        if (!window.confirm(`Delete "${ev.title}"? This cannot be undone.`)) return;
        try {
            await api.delete(`/admin/events/${ev.id}`);
            toast.success("Event deleted.");
            onChanged();
        } catch (err) {
            toast.error(formatApiError(err));
        }
    };

    if (loading) return <Loader2 className="animate-spin" />;

    if (events.length === 0) {
        return (
            <div className="card-soft p-8 text-center">
                <Calendar size={22} className="text-brand-green mx-auto" />
                <h3 className="mt-3 font-heading font-semibold text-brand-navy dark:text-slate-100">No events yet.</h3>
                <p className="text-brand-muted text-sm mt-1">Click "New Event" to add your first upcoming event.</p>
            </div>
        );
    }

    return (
        <div className="space-y-3">
            {events.map((ev) => (
                <div key={ev.id} className="card-soft p-5 flex flex-col md:flex-row md:items-center gap-3">
                    <div className="flex-1">
                        <div className="flex items-center gap-2 flex-wrap">
                            <h3 className="font-heading font-semibold text-brand-navy dark:text-slate-100">{ev.title}</h3>
                            <Badge variant="outline" className="text-xs">{ev.date}</Badge>
                            {!ev.is_active && <Badge variant="secondary" className="text-xs">Hidden</Badge>}
                        </div>
                        {ev.location && <div className="text-sm text-brand-muted mt-1">{ev.location}</div>}
                        {ev.description && <div className="text-sm text-brand-muted mt-1">{ev.description}</div>}
                    </div>
                    <div className="flex gap-2">
                        <button onClick={() => onEdit(ev)} data-testid={`admin-event-edit-${ev.id}`} className="px-3 py-2 rounded-lg border border-border hover:border-brand-navy text-sm flex items-center gap-1.5"><Edit3 size={14} /> Edit</button>
                        <button onClick={() => removeEvent(ev)} data-testid={`admin-event-delete-${ev.id}`} className="px-3 py-2 rounded-lg border border-destructive/30 text-destructive hover:bg-destructive hover:text-white text-sm flex items-center gap-1.5"><Trash2 size={14} /> Delete</button>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default EventsTab;
